/**
 * DownloadInstagramContent 骨架屏组件
 *
 * CLS 优化：为 DownloadInstagramContent 提供布局稳定的骨架屏
 *
 * 问题：useWindowSize() 在 SSR/CSR 水合时 width 值不一致，
 *       导致条件渲染 (width <= 768) 结果改变，引起布局跳动
 *
 * 解决：初始显示骨架屏，客户端确定 width 后骨架屏和内容同帧切换
 */
import { Skeleton } from 'antd';
import styles from './index.module.less';
import { cn } from '@/lib/utils';

interface DownloadInstagramContentSkeletonProps {
  /** 是否有描述文字 */
  hasDesc?: boolean;
  /** 卡片数量 */
  cardCount?: number;
}

export default function DownloadInstagramContentSkeleton({
  hasDesc = true,
  cardCount = 3,
}: DownloadInstagramContentSkeletonProps) {
  return (
    <div className={styles.content}>
      {/* 标题骨架 */}
      <div className={cn('flex justify-center', { 'mb-[3.125rem]': !hasDesc })}>
        <Skeleton.Input active style={{ width: 300, height: 36 }} />
      </div>

      {/* 描述骨架 */}
      {hasDesc && (
        <div className="mt-8 mb-[3.125rem] flex justify-center">
          <Skeleton.Input active style={{ width: 400, height: 24 }} />
        </div>
      )}

      {/* 卡片列表骨架 */}
      <div className={styles.contentList}>
        {Array.from({ length: cardCount }, (_, index) => (
          <div key={index} className={styles.contentItem}>
            <div className={cn(styles.contentItemTitle, styles.selected)}>
              {/* 序号 */}
              <Skeleton.Input active style={{ width: 24, height: 28 }} />
              {/* 标题 */}
              <Skeleton.Input active style={{ width: 150, height: 20 }} />
              {/* 描述 */}
              <Skeleton.Input active style={{ width: '100%', height: 16 }} />
            </div>
            {/* 图片占位 */}
            <div className={styles.contentItemImg}>
              <div className="w-full h-full bg-gray-200 animate-pulse" style={{ aspectRatio: '1/1' }} />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
